import Skeleton from 'react-loading-skeleton'
import { ScrollableRestaurants } from '~/components/ScrollableRestaurants'
import { isEmpty } from '~/lib/empty'
import { css } from '~/styled-system/css'
import { hstack, vstack } from '~/styled-system/patterns'
import { PrefectureTab } from '../PrefectureTab'
import { Section } from '../Section'
import { usePopularRestaurants, useSelectedArea, useSetSelectedArea } from './restaurants'

export function PopularityRestaurants() {
  const { data } = usePopularRestaurants()
  if (data?.searchRestaurants.edges.length === 0) {
    return null
  }
  return (
    <Section
      title="人気のレストラン ランキング"
      titleSideContent={<PrefectureTab useSelected={useSelectedArea} useSet={useSetSelectedArea} />}
    >
      <Body />
    </Section>
  )
}

function Body() {
  const { data } = usePopularRestaurants()
  if (isEmpty(data)) {
    // TODO: ローディング表示
    return <Loading />
  }
  const restaurants = data.searchRestaurants.edges.map((e) => e.node)
  return (
    <ScrollableRestaurants
      restaurants={restaurants}
      linkTo={(restaurantId) => `/${restaurantId}`}
      rankingBadge
    />
  )
}

function Loading() {
  return (
    <div
      className={hstack({
        alignItems: 'stretch',
        gap: '3',
        w: '[1000px]',
        px: '[2px]',
        pb: '3',
        overflow: 'hidden',
      })}
    >
      {Array.from({ length: 5 }, (_, i) => (
        <div
          key={i}
          className={vstack({
            alignItems: 'start',
            gap: '0',
            flexShrink: 0,
            borderRadius: 'md',
            shadow: 'outline.sm',
          })}
        >
          <Skeleton height={137} width={210} />
          <div className={css({ p: '3', spaceY: '1' })}>
            <Skeleton height={18} width={185} />
            <Skeleton height={14} width={60} />
            <Skeleton height={16} width={100} />
          </div>
        </div>
      ))}
    </div>
  )
}
